import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set a fixed countdown of 2 hours for urgency
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex justify-center gap-4 my-6" data-id="element-135" data-mp="3h0z7la64y53x">
      <div className="flex flex-col items-center" data-id="element-136" data-mp="3h1qttudueqhj">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-137" data-mp="323ybkugwvnzn">
          {hours.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-138" data-mp="10c3fvob1vu32">
          Horas
        </span>
      </div>
      <div className="text-2xl font-bold text-teal-500 mt-4" data-id="element-139" data-mp="15awk0q4g68qk">:</div>
      <div className="flex flex-col items-center" data-id="element-140" data-mp="y0endtowvxxs">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-141" data-mp="xz3kdw3aiu7q">
          {minutes.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-142" data-mp="12rwtew5skopm">
          Minutos
        </span>
      </div>
      <div className="text-2xl font-bold text-teal-500 mt-4" data-id="element-143" data-mp="f3dgg3bsrnr7">:</div>
      <div className="flex flex-col items-center" data-id="element-144" data-mp="a3hc22z6tub4">
        <div className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-bold text-teal-700 border border-emerald-100" data-id="element-145" data-mp="a4she78a7a4c">
          {seconds.toString().padStart(2, '0')}
        </div>
        <span className="text-xs text-gray-600 mt-2 font-medium uppercase tracking-wider" data-id="element-146" data-mp="k3i1m6nnh6nr">
          Segundos
        </span>
      </div>
    </div>;
}